<template>
    <div>
        <Card>
            <p slot="title"> Tambah Pembayaran Pending </p>

            <Form :label-width="120">
                <template v-if="paymentPendingId">
                    <PaymentPendingRowCard :paymentPendingId="paymentPendingId" :isSpecialMarking="isSpecialMarking" />
                    <br />
                    <hr /> <br />
                </template>

                <Spin v-if="isLoadingContent" size="large"></Spin>
                <div v-else>
                    <Form-item label="Tgl Pembayaran">
                        <Row>
                            <Col span="4">
                            <Date-picker v-model="paymentDate" disabled readonly type="date" format="dd/MM/yyyy">
                            </Date-picker>

                            </Col>
                            <Col span="2">
                            <Select v-if="searchSelectSubbranch == 'JKT'" v-model="searchSelectSubbranch" disabled
                                placeholder="Branchcode" @on-change="setMarkingCode">
                                <Option v-for="subbranch, idx in subbranchs" :value="subbranch.subbranchcode"
                                    :key="idx">
                                    {{ subbranch.subbranchname }}
                                </Option>
                            </Select>
                            <Select v-else v-model="searchSelectSubbranch" disabled placeholder="Branchcode"
                                @on-change="setMarkingCode">
                                <Option v-for="subbranch, idx in subbranchs" :value="subbranch.subbranchcode"
                                    :key="idx">
                                    {{ subbranch.subbranchname }}
                                </Option>
                            </Select>

                            </Col>
                            <Col span="1">&nbsp;
                            </Col>
                            <Col span="3"
                                v-if="paymentDate != '' && (paymentPendingMarking || paymentPendingMarkingGroup)">
                            <i-switch size="large" v-model="isGroup" disabled>
                                <span slot="open">Group</span>
                                <span slot="close">Mark</span>
                            </i-switch>
                            </Col>
                            <Col span="3" v-else="paymentDate !=''">
                            <i-switch size="large" v-model="isGroup">
                                <span slot="open">Group</span>
                                <span slot="close">Mark</span>
                            </i-switch>
                            </Col>
                            <Col span="5"
                                v-show="paymentDate != '' && isGroup == false && paymentPendingId && paymentPendingMarking">
                            <Input v-model="paymentPendingMarking" style="width: 200px;" disabled></Input>
                            </Col>
                            <Col span="5"
                                v-show="paymentDate != '' && isGroup == false && paymentPendingId && paymentPendingMarking == ''">
                            <Select style="width: 250px;" placeholder="Ketik Marking" v-model="markingIdSelected"
                                filterable clearable remote disabled :remote-method="getMarkingByCode"
                                :loading="loadingGetMarking" @on-change="getInvoiceData">
                                <Option v-for="option in optionMarkings" :value="option.value" :key="option.value">
                                    {{ option.label }}
                                </Option>
                            </Select>
                            </Col>
                            <!-- <Col span="5" v-show="paymentDate !='' && isGroup == false && paymentPendingId && paymentPendingMarking == ''">
                            <Button
                                type="primary"
                                :loading="loadingPost"
                                @click="getInvoiceData"
                                icon="ios-search"
                                size="small">
                                    Search
                                </Button>
                        </Col> -->
                            <Col span="5"
                                v-show="paymentDate != '' && isGroup == true && paymentPendingId && paymentPendingMarkingGroup">
                            <Input v-model="paymentPendingMarkingGroup" style="width: 200px;" disabled></Input>
                            </Col>
                            <Col span="5"
                                v-if="paymentDate != '' && isGroup == true && paymentPendingId && paymentPendingMarkingGroup == ''">
                            <Select style="width: 250px;" placeholder="Ketik Group Name" v-model="markingIdSelected"
                                filterable clearable remote :remote-method="getGroupMarkingByCode"
                                :loading="loadingGetMarking" @on-change="getInvoiceDataByGroupMarking">
                                <Option v-for="option in optionGroupMarkings" :value="option.value" :key="option.value">
                                    {{ option.label }}
                                </Option>
                            </Select>
                            </Col>
                            <Col span="1" offset="1">
                            <Spin size="large" v-show="loadingGetPayment"></Spin>
                            </Col>


                        </Row>
                    </Form-item>
                    <Form-item label="Keterangan"
                        v-show="paymentDate != '' && markingIdSelected != '' && invoiceDues.length > 0">
                        <Input v-model="description" style="width: 30%;"></Input>
                    </Form-item>
                    <Form-item label="Klaim" prop="claim">
                        <Select placeholder="Masukan Klaim yang sesuai dengan Mutasi" v-model="claims" filterable multiple :disabled="optionClaims.length === 0"
                            style="width: 30%;">
                            <Option v-for="(option, index) in optionClaims" :value="option.value" :key="index">
                                {{ option.label }}</Option>
                        </Select>
                        <Button type="info" icon="ios-refresh" @click="getClaims" :loading="loadingGetClaims">Refresh Klaim</Button>
                    </Form-item>
                    <Form-item v-if="isSpecialMarking" label="Total Deposit"
                        v-show="paymentDate != '' && markingIdSelected != '' && depositRemaining != 0">
                        <Alert style="width: 30%;" type="warning" show-icon> {{ depositRemaining | currencyInter }}
                        </Alert>
                        <font style="color: red;"
                            v-if="totalUseDepositAmount > 0 && totalUseDepositAmount > depositRemaining">Terpakai
                            {{ totalUseDepositAmount | currencyInter }} - LEBIH
                        </font>
                        <font style="color: green;"
                            v-if="totalUseDepositAmount > 0 && totalUseDepositAmount <= depositRemaining">
                            Terpakai: {{ totalUseDepositAmount | currencyInter }}, Sisa: {{ (depositRemaining -
                                totalUseDepositAmount) |
                                currencyInter }}
                        </font>
                    </Form-item>
                    <Form-item v-else label="Total Deposit"
                        v-show="paymentDate != '' && markingIdSelected != '' && depositRemaining != 0">
                        <Alert style="width: 30%;" type="warning" show-icon> {{ depositRemaining | currency }}
                        </Alert>
                        <font style="color: red;"
                            v-if="totalUseDepositAmount > 0 && totalUseDepositAmount > depositRemaining">Terpakai
                            {{ totalUseDepositAmount | currency }} - LEBIH
                        </font>

                        <font style="color: green;"
                            v-if="totalUseDepositAmount > 0 && totalUseDepositAmount <= depositRemaining">
                            Terpakai: {{ totalUseDepositAmount | currency }}, Sisa: {{ (depositRemaining -
                                totalUseDepositAmount) |
                                currency }}
                        </font>
                    </Form-item>
                    <Form-item label="Total Mutasi Deposit"
                        v-show="paymentDate != '' && markingIdSelected != '' && invoiceDues.length > 0 && depositMutasiRemaining">
                        <Alert style="width: 30%;" type="warning" show-icon>
                            {{ depositMutasiRemaining | currencyInter }}
                        </Alert>

                        <font style="color: red;"
                            v-if="totalUseDepositMutasi > 0 && totalUseDepositMutasi > depositMutasiRemaining">
                            Terpakai
                            {{ totalUseDepositMutasi | currency }} - LEBIH
                        </font>

                        <font style="color: green;"
                            v-if="totalUseDepositMutasi > 0 && totalUseDepositMutasi <= depositMutasiRemaining">
                            Terpakai: {{ totalUseDepositMutasi | currency }}, Sisa: {{ (depositMutasiRemaining -
                                totalUseDepositMutasi) |
                                currency }}
                        </font>
                    </Form-item>

                    <Form-item v-if="isSpecialMarking" :label="'Deposit ' + selectGroup"
                        v-show="paymentDate != '' && markingIdSelected != '' && groupDepositRemaining != 0 && isGroup">
                        <Alert style="width: 30%;" type="warning" show-icon> {{ groupDepositRemaining | currencyInter
                            }}
                        </Alert>
                    </Form-item>
                    <Form-item v-else :label="'Deposit ' + selectGroup"
                        v-show="paymentDate != '' && markingIdSelected != '' && groupDepositRemaining != 0 && isGroup">
                        <Alert style="width: 30%;" type="warning" show-icon> {{ groupDepositRemaining | currency }}
                        </Alert>
                    </Form-item>

                    <Form-item v-if="isSpecialMarking" label="Uang Diterima"
                        v-show="paymentDate != '' && markingIdSelected != '' && invoiceDues.length > 0">
                        <!-- <Alert
                        show-icon
                        style="width: 30%;"
                        :type="isbalanceAmount ? 'success' : 'warning'" >{{ amountReceived | currency }}</Alert> -->
                        <money disabled v-model="amountReceived" v-bind="moneyInter" class="ivu-input right"
                            style="width: 150px;">
                        </money>
                        <font v-show="amountResidue != 0" style="margin-left: 20px;">
                            Selisih &nbsp; {{ amountResidue | currencyInter }}
                        </font>
                    </Form-item>
                    <Form-item v-else label="Uang Diterima"
                        v-show="paymentDate != '' && markingIdSelected != '' && invoiceDues.length > 0">
                        <!-- <Alert
                        show-icon
                        style="width: 30%;"
                        :type="isbalanceAmount ? 'success' : 'warning'" >{{ amountReceived | currency }}</Alert> -->
                        <money disabled v-model="amountReceived" v-bind="money" class="ivu-input right"
                            style="width: 150px;">
                        </money>
                        <font v-show="amountResidue != 0" style="margin-left: 20px;">
                            Selisih &nbsp; {{ amountResidue | currency }}
                        </font>
                    </Form-item>

                    <!-- <Form-item label="Pembulatan"
                    v-show="paymentDate !='' && markingIdSelected != '' && invoiceDues.length > 0">
                    <money
                        v-model="creditRound"
                        v-bind="money"
                        class="ivu-input right"
                        style="width: 150px;"></money>
                </Form-item> -->
                    <Form-item label="Chart of Account"
                        v-show="paymentDate != '' && markingIdSelected != '' && invoiceDues.length > 0 && creditRound > 0">
                        <Select v-model="coaId" clearable filterable style="width: 30%;">
                            <Option v-for="coa in COAs" :value="coa.id" :key="coa.id">{{ coa.account_name }}</Option>
                        </Select>
                    </Form-item>

                    <Form-item label="Uang Potongan"
                        v-show="paymentDate != '' && markingIdSelected != '' && invoiceDues.length > 0 && paymentPendingId">
                        <money v-if="isSpecialMarking" v-model="discountReceived" v-bind="moneyInter"
                            class="ivu-input right" style="width: 150px;">
                        </money>
                        <money v-else v-model="discountReceived" v-bind="money" class="ivu-input right"
                            style="width: 150px;">
                        </money>
                    </Form-item>

                    <Form-item label="Kategori"
                        v-show="paymentDate != '' && markingIdSelected != '' && invoiceDues.length > 0 && paymentPendingId == null">
                        <input type="radio" v-model="category" id="payment" value="pay"> <label
                            for="payment">Pembayaran</label>
                        &nbsp;&nbsp;&nbsp;
                        <input type="radio" v-model="category" id="discount" value="disc"> <label
                            for="discount">Potongan</label>
                    </Form-item>
                    <Form-item label="Kategori"
                        v-show="paymentDate != '' && markingIdSelected != '' && invoiceDues.length > 0 && paymentPendingId">
                        <input type="radio" v-model="category" id="payment" value="pay"> <label
                            for="payment">Pembayaran</label>
                        &nbsp;&nbsp;&nbsp;
                    </Form-item>

                    <Alert v-if="isSpecialMarking" v-show="depositAmount != 0" type="warning" show-icon
                        style="width: 30%;">Kelebihan
                        : {{ depositAmount | currencyInter }}</Alert>
                    <Alert v-else v-show="depositAmount != 0" type="warning" show-icon style="width: 30%;">Kelebihan :
                        {{ depositAmount | currency }}</Alert>

                    <Alert v-show="!isbalanceAmount && !loadingGetPayment" type="error" show-icon style="width: 100%;">
                        Tidak dapat melanjutkan proses pembayaran jika Uang Diterima tidak sama dengan Mutasi.
                        <strong>Selisih : {{ diffAmount | currencyInter }}</strong></Alert>
                    <Alert v-show="optionClaims.length == 0" type="warning" show-icon style="width: 100%;">
                        Tidak ada Klaim pada hari ini untuk Marking ini</Alert>
                    <Alert v-show="depositAmount != 0 && category == 'disc'" type="error" show-icon
                        style="width: 700px;"> Tidak dapat melanjutkan proses pembayaran jika terdapat Kelebihan pada Kategori Potongan.</Alert>

                    <Button v-if="isSpecialMarking" v-show="isGroup && !loadingGetPayment">Total Alokasi Marking {{
                        selectGroup }} : {{ totalAmountSelect | currencyInter }}</Button>
                    <Button v-else v-show="isGroup && !loadingGetPayment">Total Alokasi Marking {{ selectGroup }} :
                        {{ totalAmountSelect | currency }}</Button>
                </div>
          </Form>
        </Card>
        <br />

        <Card v-show="this.invoiceDues.length > 0 && receivableGroup == ''">
            <p slot="title"> Daftar Invoices </p>

            <Row type="flex" class="code-row-bg ivu-row-flex-space-between">
                <template>
                    <Col span="2"> Tgl Bongkar </Col>
                    <Col span="6"> Keterangan </Col>
                    <Col span="3"> Total </Col>
                    <Col span="3"> Sisa </Col>
                    <Col span="3"> Alokasi Pembayaran </Col>
                    <Col span="5"> Potongan </Col>
                </template>
            </Row>

            <br />
            <hr /> <br />

            <div>
                <div v-if="paymentPendingMarking.includes('SBR/') || paymentPendingMarking.includes('SBRT/') || paymentPendingMarking.includes('CTH/')">
                    <div v-for="invoiceDue in invoiceDues" :key="invoiceDue.id">
                        <cInvoicePaymentDecimal :invoiceDue="invoiceDue" :depositRemaining="depositRemaining"
                            :paymentPendingId="paymentPendingId"
                            :depositMutasiRemaining="depositMutasiRemaining"
                            :paymentPendingAmount="paymentPendingAmount"
                            @setAllocateAmount="setAllocateAmount"></cInvoicePaymentDecimal>
                        <br />
                    </div>
                </div>
                <div v-else>
                    <div v-for="invoiceDue in invoiceDues" :key="invoiceDue.id">
                        <cInvoicePayment :invoiceDue="invoiceDue" :depositRemaining="depositRemaining"
                            :depositMutasiRemaining="depositMutasiRemaining"
                            :paymentPendingId="paymentPendingId"
                            :paymentPendingAmount="paymentPendingAmount"
                            @setAllocateAmount="setAllocateAmount"></cInvoicePayment>
                        <br />
                    </div>
                </div>
            </div>

        </Card>

        <Card v-if="receivableGroup != ''">
            <Tabs :animated="false" @on-click="groupClickHandle">
                <TabPane v-for="marking in receivableGroup" :key="marking.markingheadercode"
                    :label="marking.markingheadercode">
                    <p slot="title"> Daftar Invoice </p>
                    <Row type="flex" class="code-row-bg">
                        <template>
                            <Col span="2"> Tgl Bongkar</Col>
                            <Col span="6"> Keterangan </Col>
                            <Col span="3"> Total </Col>
                            <Col span="3"> Sisa </Col>
                            <Col span="3"> Alokasi Pembayaran </Col>
                            <Col span="5"> Potongan </Col>
                        </template>
                    </Row>
                    <br />
                    <hr /> <br />

                    <div>
                        <div
                            v-if="paymentPendingMarkingGroup.includes('SBR/') || paymentPendingMarkingGroup.includes('SBRT/') || paymentPendingMarkingGroup.includes('CTH/')">
                            <div v-for="invoiceDue in marking.invoiceDue" :key="invoiceDue.id">
                                <cInvoicePaymentDecimal :invoiceDue="invoiceDue" :depositRemaining="depositRemaining"
                                    :depositMutasiRemaining="depositMutasiRemaining"
                                    :paymentPendingId="paymentPendingId" :paymentPendingAmount="paymentPendingAmount"
                                    @setAllocateAmount="setAllocateAmount">
                                </cInvoicePaymentDecimal>
                                <br />
                            </div>
                        </div>
                        <div v-else>
                            <div v-for="invoiceDue in marking.invoiceDue" :key="invoiceDue.id">
                                <cInvoicePayment :invoiceDue="invoiceDue" :depositRemaining="depositRemaining"
                                    :depositMutasiRemaining="depositMutasiRemaining"
                                    :paymentPendingId="paymentPendingId" :paymentPendingAmount="paymentPendingAmount"
                                    @setAllocateAmount="setAllocateAmount">
                                </cInvoicePayment>
                                <br />
                            </div>
                        </div>
                    </div>
                </TabPane>
            </Tabs>
        </Card>

        <div class="footer" v-show="isGroup == false">
            <Button
                v-show="description != '' && category != '' && (((totalUseDepositAmount <= depositRemaining) || depositRemaining < 0) ||
                    ((totalUseDepositMutasi <= depositMutasiRemaining) || depositMutasiRemaining < 0))
                && paymentPendingId == null && (creditRound == 0 || creditRound > 0 && coaId != null)" type="primary"
                :loading="loadingPost" @click="postPayment" icon="checkmark-round" size="small">
                <span v-if="!loadingPost && amountReceived + totalUseDepositAmount + totalUseDepositMutasi > 0">Bayar</span>
                <span v-else-if="!loadingPost && (amountReceived == 0)">Bayar Free</span>
                <span v-else>Wait.....</span>
            </Button>
        </div>
        <div class="footer" v-show="isGroup == false && isbalanceAmount">
            <Button v-show="description != '' && category != '' &&
                (((totalUseDepositAmount <= depositRemaining) || depositRemaining < 0) ||
                    ((totalUseDepositMutasi <= depositMutasiRemaining) || depositMutasiRemaining < 0)) &&
                ((depositAmount == 0 && category == 'disc') || (depositAmount >= 0 && category == 'pay')) &&
                ((paymentPendingId && depositAmount <= paymentPendingAmount) || paymentPendingId == null) &&
                (creditRound == 0 || creditRound > 0 && coaId != null)" type="primary" :loading="loadingPost"
                @click="postPaymentPending" icon="checkmark-round" size="small">
                <span
                    v-if="!loadingPost && amountReceived + totalUseDepositAmount + totalUseDepositMutasi > 0">Bayar</span>
                <span v-else-if="!loadingPost && (amountReceived == 0)">Bayar Free</span>
                <span v-else>Wait.....</span>
            </Button>
        </div>
        <div class="footer" v-show="isGroup && isbalanceAmount">
            <Button
                v-show="description != '' && category != '' && ((totalUseDepositAmount <= depositRemaining) || depositRemaining < 0) && (creditRound == 0 || creditRound > 0 && coaId != null)"
                type="primary" :loading="loadingPost" @click="postPaymentByGroup" icon="checkmark-round" size="small">
                <span v-if="!loadingPost && amountReceived + totalUseDepositAmount + totalUseDepositMutasi > 0">Bayar</span>
                <span v-else-if="!loadingPost && (amountReceived == 0)">Bayar Free</span>
                <span v-else>Wait.....</span>
            </Button>
        </div>

        <Modal v-model="modalConfirmDeposit" width="500px" @on-cancel="depositType = ''">
            <p slot="header" style="color:#2d8cf0;text-align:center">
                <Icon type="information-circled"></Icon>
                <span>Konfirmasi</span>
            </p>
            Kelebihan <b>{{ depositAmount | currency }}</b> akan dijadikan sebagai :
            <div style="text-align:left">
                <RadioGroup v-model="depositType" vertical>
                    <Radio label="DFM">
                        <span>Deposit</span>
                    </Radio>
                    <Radio label="PRF">
                        <span>Pendapatan</span>
                    </Radio>
                </RadioGroup>
            </div>
            <div slot="footer" v-show="isGroup == false && paymentPendingId == null">
                <Button v-show="depositType != ''" type="primary" long :loading="loadingPost" @click="postPayment">
                    <span v-if="!loadingPost">Bayar</span>
                    <span v-else>Wait.....</span>
                </Button>
            </div>
            <div slot="footer" v-show="isGroup == false && paymentPendingId">
                <Button v-show="depositType != ''" type="primary" long :loading="loadingPost"
                    @click="postPaymentPending">
                    <span v-if="!loadingPost">Bayar</span>
                    <span v-else>Wait.....</span>
                </Button>
            </div>
            <div slot="footer" v-show="isGroup">
                <Button v-show="depositType != ''" type="primary" long :loading="loadingPost"
                    @click="postPaymentByGroup">
                    <span v-if="!loadingPost">Bayar</span>
                    <span v-else>Wait.....</span>
                </Button>
            </div>
        </Modal>

        <!-- Modal - konfirmasi mutasi akan dialokasikan menjadi piutang -->
        <Modal v-model="modalConfirmAutoDeposit" width="500px">
            <p slot="header" style="color:#2d8cf0;text-align:center">
                <Icon type="information-circled"></Icon>
                <span>Konfirmasi</span>
            </p>

            <p>
                Marking tidak memiliki piutang, apakah mutasi dengan Total : <b> Rp. {{ paymentPendingAmount | currency
                }} </b>
                ingin dijadikan sebagai <b>Deposit</b> ?
            </p>

            <div slot="footer">
                <Button type="error" @click="modalConfirmAutoDeposit = false">Batalkan</Button>
                <Button type="primary" :loading="loadingPost" @click="postReceivableAsDeposit">
                    <span v-if="!loadingPost">Tambahkan</span>
                    <span v-else>Mohon tunggu...</span>
                </Button>
            </div>
        </Modal>
    </div>
</template>

<script>
import { HTTP } from '../http-lib';
import { Money } from 'v-money'
import _ from 'lodash'
import moment from 'moment'
import cInvoicePayment from '@/components/payment/cInvoicePayment'
import cInvoicePaymentDecimal from '@/components/payment/cInvoicePaymentDecimal'
import PaymentPendingRowCard from '@/components/payment/PaymentPendingRowCard'
import { concat } from 'lodash';

const numeral = require('numeral');
var axios = require('axios');

export default {
    components: { cInvoicePayment, cInvoicePaymentDecimal, Money, PaymentPendingRowCard },
    props: {
        paymentPendingId: Number,
        paymentDateProp: String,
        paymentPendingAmount: Number,
        paymentPendingMarking: String,
        paymentPendingMarkingGroup: String,
        isPayment: Boolean,
        markingIdSelected: Number,
        isGroup: Boolean,
        uriType: String,
        bankAccountId: Number,
        startEndDate: String
    },

    data: () => ({
        optionMarkings: [],
        optionGroupMarkings: [],
        receivableGroup: [],
        modalConfirmDeposit: false,
        amountReceived: 0,
        discountReceived: '',
        amountResidue: '',
        depositType: '',
        depositAmount: '', // untuk menampung kelebihan bayar
        depositRemaining: 0, // untuk menampung total sisa deposit
        depositMutasiRemaining: 0,
        groupDepositRemaining: 0,
        totalUseDepositAmount: 0,
        totalUseDepositMutasi: 0,
        loadingGetPayment: false,
        accountNumber: '',
        paymentDate: '',
        description: '',
        transactionDate: '',
        loadingGetMarking: false,
        invoiceDues: [],
        loadingPost: false,
        paymentAllocates: [],
        postData: [],
        payments: [],
        searchSelectSubbranch: localStorage.getItem('user.subbranchcode'),
        username: localStorage.getItem('user.username'),
        subbranchs: '',
        isbalanceAmount: (this.amountReceived - this.totalUseDepositMutasi) == this.paymentPendingAmount,
        diffAmount: this.paymentPendingAmount - (this.amountReceived - this.totalUseDepositMutasi),
        selectGroup: '',
        totalAmountSelect: 0,
        loadingGetClaims: false,
        optionClaims: [],
        claims: [],
        receivableClaim: [],
        tableColumns: [
            {
                title: 'Tgl',
                key: 'paymentDate',
                sortable: false
            },
            {
                title: 'Marking',
                key: 'markingHeaderId',
                sortable: false
            },
            {
                title: 'Keterangan',
                key: 'description',
                sortable: false
            },
            {
                title: 'Jumlah',
                key: 'creditAmount',
                sortable: false
            }
        ],
        filterInput: '',
        money: {
            decimal: ',',
            thousands: '.',
            prefix: '',
            suffix: '',
            precision: 0,
            masked: false
        },
        moneyInter: {
            decimal: ',',
            thousands: '.',
            prefix: '',
            suffix: '',
            precision: 2,
            masked: false
        },
        category: '',
        creditRound: 0,
        coaId: null,
        COAs: [],
        listMarkingGroup: [],
        modalConfirmAutoDeposit: false,
        isLoadingContent: false,
        isSpecialMarking: false,
    }),
    methods: {
        isDeviation: function (invoiceDue) {
            if (invoiceDue.allocateAmount + invoiceDue.useDepositAmount + invoiceDue.useDepositMutasi > invoiceDue.receivableRemaining) {
                return true;
            }
            return false;
        },
        countTotalAllocateAmount: function (invoiceDue) {
            return (invoiceDue.allocateAmount + invoiceDue.useDepositAmount + invoiceDue.useDepositMutasi) - invoiceDue.receivableRemaining;
        },
        setAllocateAmount: function (invoiceDue) {
            if (this.isDeviation(invoiceDue)) {
                invoiceDue.deviationAmount = this.countTotalAllocateAmount(invoiceDue)
            } else {
                invoiceDue.deviationAmount = 0
            }

            var index = _.findIndex(this.invoiceDues, { id: invoiceDue.id });

            // Replace item at index using native splice
            this.invoiceDues.splice(index, 1, invoiceDue);

            // var invoiceDueChanged = _.find(this.invoiceDues, {id: invoiceDue.id});
            this.setResidueAmount(true);

            this.totalAmountSelect = 0
            if (this.receivableGroup.length > 0) {
                this.receivableGroup.find(o => o.markingheadercode == this.selectGroup).invoiceDue.forEach(o => {
                    this.totalAmountSelect += o.allocateAmount
                })
            }
        },
        countTotalAllocateMutasiAmount: function (invoiceDue) {
            return (invoiceDue.allocateMutasiAmount + invoiceDue.useDepositMutasi) - invoiceDue.receivableRemaining;
        },
        setAllocateMutasiAmount: function (invoiceDue) {
            if (this.isDeviation(invoiceDue)) {
                invoiceDue.deviationAmount = this.countTotalAllocateMutasiAmount(invoiceDue)
            } else {
                invoiceDue.deviationAmount = 0
            }

            var index = _.findIndex(this.invoiceDues, { id: invoiceDue.id });

            // Replace item at index using native splice
            this.invoiceDues.splice(index, 1, invoiceDue);

            // var invoiceDueChanged = _.find(this.invoiceDues, {id: invoiceDue.id});
            this.setResidueAmount(true);

            this.totalAmountSelect = 0

            if (this.isGroup) {
                this.receivableGroup.find(o => o.markingheadercode == this.selectGroup).invoiceDue.forEach(o => {
                    this.totalAmountSelect += o.allocateAmount
                })
            }
        },
         setResidueAmount: function (fromChild) {
            let allocateAmounts = _.sumBy(this.invoiceDues, 'allocateAmount');
            let allocateDiscountAmounts = _.sumBy(this.invoiceDues, 'discountAmount');
            let allocateDepositMutasi = _.sumBy(this.invoiceDues, 'useDepositMutasi');
            this.amountResidue = this.amountReceived - (allocateAmounts + allocateDepositMutasi);

            if (fromChild) {
                this.amountReceived = allocateAmounts + allocateDepositMutasi;
                this.totalUseDepositAmount = _.sumBy(this.invoiceDues, 'useDepositAmount');
                this.totalUseDepositMutasi = _.sumBy(this.invoiceDues, 'useDepositMutasi');
                this.discountReceived = allocateDiscountAmounts;
            }

            let sumDeviation = _.sumBy(this.invoiceDues, 'deviationAmount');
            console.log('sumDeviation', sumDeviation);

            this.depositAmount = sumDeviation
        },
        getDepositRemaining: function (markingSelect) {
            if (this.markingIdSelected !== '') {
                let payload = {
                    markingHeaderId: this.markingIdSelected,
                    transactionDate: moment(this.paymentDate).format('YYYY-MM-DD')
                }

                return HTTP.post('deposit-filter/remaining', payload)
            } else {
                this.depositRemaining = 0;
            }
        },
        getDepositMutasiRemaining: function () {
            if (this.markingIdSelected !== '') {
                let payload = {
                    markingHeaderId: this.markingIdSelected,
                    transactionDate: moment(this.paymentDate).format('YYYY-MM-DD')
                }

                return HTTP.post('deposit-filter/mutasi', payload)
            } else {
                this.depositMutasiRemaining = 0;
            }
        },
        getInvoiceDueUnSettled: function () {
            if (this.markingIdSelected !== '') {
                return HTTP.get('invoiceDue/unsettled/' + this.markingIdSelected)
            } else {
                this.invoiceDues = []
            }
        },
        getInvoiceDueUnSettledByGroup: function () {
            if (this.markingIdSelected !== '') {
                return HTTP.get('invoiceDue/unsettledByGroup/' + this.markingIdSelected)
            } else {
                this.invoiceDues = []
            }
        },
        getSubbranch: function () {
            HTTP
                .get('subbranch')
                .then(response => {
                    this.subbranchs = response.data
                })
                .catch(e => {
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                })
        },
        getInvoiceData: function () {
            this.loadingGetPayment = true;
            this.isLoadingContent = true;

            this.invoiceDues = []
            this.amountResidue = ''
            this.amountReceived = 0
            this.description = ''
            this.depositRemaining = 0;
            this.totalUseDepositAmount = 0;
            this.totalUseDepositMutasi = 0;

            if (this.markingIdSelected == '' || this.isGroup) {
                this.loadingGetPayment = false;
                return;
            }

            let parent = this;

            axios.all([
                this.getInvoiceDueUnSettled(),
                this.getDepositRemaining(this.markingIdSelected),
                this.getDepositMutasiRemaining()
            ]).then(axios.spread((unSettledRes, depositRemainingRes, depositMutasiRes) => {
                let invoiceDuesFormatted = []
                _.forEach(unSettledRes.data, function (value) {

                    let receivableType = value.receivable.type;

                    let invoicefee = value.receivable.debitAmount;
                    let invoicedate = value.receivable.transactionDate;
                    let invoicedatedue = '';

                    if (receivableType != 'MAN') {
                        let invoicefee = value.receivable.invoice.invoicefee;
                        let invoicedatedue = value.receivable.invoice.invoicedatedue;
                        let invoicedate = value.receivable.invoice.invoicedate;
                    }

                    let paymentSum = value.paymentSum;
                    let receivableRemaining = invoicefee - paymentSum;
                    let receivableDebitAmount = value.receivable.debitAmount;
                    let currency = null
                    if (parent.isSpecialMarking) {
                        if (value.receivable.invoice) {
                            currency = value.receivable.invoice.packaging_list.container_loading.currency_sgd;
                        } else if (value.receivable) {
                            currency = value.receivable.currency_sgd;
                        }
                    }
                    let invoicefeeIdr = 0
                    let receivableRemainingIdr = 0
                    if (value.receivable.invoice && (value.receivable.invoice.currency == 'SGD' || value.receivable.invoice.currency == 'BAHT') && parent.isSpecialMarking) {
                        let currencyRate = currency ? currency.currencyrate : 1
                        invoicefeeIdr = parseFloat(invoicefee) * parseFloat(currencyRate);
                        receivableRemaining = (invoicefee - paymentSum).toFixed(2);
                        receivableRemainingIdr = parseFloat(receivableRemaining) * parseFloat(currencyRate);
                    }

                    let payment = {
                        id: value.id,
                        receivableId: value.receivableId,
                        invoicefee: invoicefee, // Jika ada invoice, nilai ini dapat berubah jika repricing
                        paymentSum: paymentSum,
                        receivableRemaining: receivableRemaining,
                        description: value.receivable.description,
                        invoicedate: invoicedate, //numeral(value.receivable.creditAmount).format('0,0')
                        invoicedatedue: invoicedatedue,
                        receivableDebitAmount: receivableDebitAmount, // menyimpan nilai awal
                        allocateAmount: 0,
                        deviationAmount: 0, // untuk menyimpan kelebihan bayar
                        useDepositAmount: 0, // nilai penggunaan deposit (jika ada deposit)
                        useDepositMutasi: 0,
                        markingHeaderId: value.receivable.markingHeaderId,
                        pendingAmount: 0,
                        discountAmount: 0,
                        currency: currency,
                        invoicefeeIdr: invoicefeeIdr,
                        receivableRemainingIdr: receivableRemainingIdr,
                        claimStatus: null,
                    }

                    invoiceDuesFormatted.push(payment);
                });

                if (invoiceDuesFormatted.length > 0) {
                    invoiceDuesFormatted = _.sortBy(invoiceDuesFormatted, ['invoicedate'], function (value) { return new Date(value); });

                    let pendingAmount = this.paymentPendingAmount;
                    let index = 0;

                    if (pendingAmount && pendingAmount > 0) {
                        _.forEach(invoiceDuesFormatted, function (value) {
                            if (pendingAmount && pendingAmount > 0 && pendingAmount > value.receivableRemaining) {
                                invoiceDuesFormatted[index].pendingAmount = value.receivableRemaining;
                                pendingAmount = pendingAmount - value.receivableRemaining;
                            } else if (pendingAmount && pendingAmount > 0 && pendingAmount <= value.receivableRemaining) {
                                invoiceDuesFormatted[index].pendingAmount = pendingAmount;
                                pendingAmount = 0;
                            }

                            index++;
                        });
                    }

                    parent.invoiceDues = invoiceDuesFormatted;
                    parent.depositRemaining = depositRemainingRes.data.remaining
                    parent.depositMutasiRemaining = depositMutasiRes.data.remaining

                } else {
                    if (this.markingIdSelected) {
                        this.$Message.info('Piutang tidak ditemukan');
                    }

                    if (this.isPayment) {
                        // this.$router.push({ path: '/payment/paymentPending/list-data/search/-' })
                        this.$router.push({ path: `/payment/paymentPending/list-data/search/${Date.now()}` })
                        this.$Message.info({
                            content:
                                'Telah dilakukan pembayaran / deposit untuk marking ' + this.paymentPendingMarking +
                                ' dengan total mutasi Rp ' + this.paymentPendingAmount,
                            duration: 5
                        });
                    } else {
                        parent.modalConfirmAutoDeposit = true
                    }
                }
                parent.loadingGetPayment = false;
                parent.isLoadingContent = false;

                this.getClaims();
            }))
                .catch(e => {
                    console.error('get invoice data', e)
                    this.loadingGetPayment = false;
                    this.isLoadingContent = false;
                    this.$Notice.error({
                        title: "Error",
                        desc: 'Silahkan Cek Menu Piutang > Hapus Piutang',
                        duration: 0
                    });
                });
        },
        getInvoiceDataByGroupMarking: function () {
            this.loadingGetPayment = true;
            this.isLoadingContent = true;

            this.invoiceDues = []
            this.amountResidue = ''
            this.amountReceived = 0
            this.description = ''
            this.groupDepositRemaining = 0;
            this.totalUseDepositAmount = 0;

            if (this.markingIdSelected == '' || this.isGroup == false) {
                this.loadingGetPayment = false;
                return;
            }

            let parent = this;

            axios.all([
                this.getInvoiceDueUnSettledByGroup(),
                this.getDepositRemaining(this.markingIdSelected),
                this.getDepositMutasiRemaining()
            ]).then(axios.spread((unSettledRes, depositRemainingRes) => {
                let invoiceDuesFormatted = []
                this.receivableGroup = []

                _.forEach(unSettledRes.data, function (value) {
                    let receivableType = value.receivable.type;

                    let invoicefee = value.receivable.debitAmount;
                    let invoicedate = value.receivable.transactionDate;
                    let invoicedatedue = '';

                    if (receivableType != 'MAN') {
                        let invoicefee = value.receivable.invoice.invoicefee;
                        let invoicedatedue = value.receivable.invoice.invoicedatedue;
                        let invoicedate = value.receivable.invoice.invoicedate;
                    }

                    let paymentSum = value.paymentSum;
                    let receivableRemaining = invoicefee - paymentSum;
                    let receivableDebitAmount = value.receivable.debitAmount;
                    let currency = null
                    if (parent.isSpecialMarking) {
                        if (value.receivable.invoice) {
                            currency = value.receivable.invoice.packaging_list.container_loading.currency_sgd;
                        } else if (value.receivable) {
                            currency = value.receivable.currency_sgd;
                        }
                    }
                    let invoicefeeIdr = 0
                    let receivableRemainingIdr = 0
                    if (value.receivable.invoice && (value.receivable.invoice.currency == 'SGD' || value.receivable.invoice.currency == 'BAHT') && parent.isSpecialMarking) {
                        let currencyRate = currency ? currency.currencyrate : 1
                        invoicefeeIdr = parseFloat(invoicefee) * parseFloat(currencyRate);
                        receivableRemainingIdr = parseFloat(receivableRemaining) * parseFloat(currencyRate);
                    }

                    let payment = {
                        id: value.id,
                        receivableId: value.receivableId,
                        invoicefee: invoicefee, // Jika ada invoice, nilai ini dapat berubah jika repricing
                        paymentSum: paymentSum,
                        receivableRemaining: receivableRemaining,
                        description: value.receivable.description,
                        invoicedate: invoicedate, //numeral(value.receivable.creditAmount).format('0,0')
                        invoicedatedue: invoicedatedue,
                        receivableDebitAmount: receivableDebitAmount, // menyimpan nilai awal
                        allocateAmount: 0,
                        deviationAmount: 0, // untuk menyimpan kelebihan bayar
                        useDepositAmount: 0, // nilai penggunaan deposit (jika ada deposit)
                        useDepositMutasi: 0,
                        markingHeaderId: value.receivable.markingHeaderId,
                        markingHeaderCode: value.receivable.marking_minified.markingheadercode,
                        currency: currency,
                        invoicefeeIdr: invoicefeeIdr,
                        receivableRemainingIdr: receivableRemainingIdr,
                    }
                    console.info('payment group', payment)
                    invoiceDuesFormatted.push(payment);
                });

                if (invoiceDuesFormatted.length > 0) {
                    invoiceDuesFormatted = _.sortBy(invoiceDuesFormatted, ['invoicedate'], function (value) { return new Date(value); });

                    parent.receivableGroup = groupBy(invoiceDuesFormatted, 'markingHeaderCode', 'markingheadercode', 'invoiceDue')

                    parent.invoiceDues = invoiceDuesFormatted;
                    parent.groupDepositRemaining = depositRemainingRes.data.remaining

                } else {
                    if (this.markingIdSelected) {
                        this.$Message.info('Piutang tidak ditemukan');
                        // parent.$Notice.error({
                        //     title: '',
                        //     desc: 'Piutang tidak ditemukan',
                        //     duration: 5
                        // });
                    }
                }
                parent.loadingGetPayment = false;
                parent.isLoadingContent = false;
                parent.groupClickHandle(0)
            }))
                .catch(e => {
                    this.loadingGetPayment = false;
                    this.isLoadingContent = false;
                    console.error('get invoice data marking group', e)

                    this.$Notice.error({
                        title: "Error",
                        desc: 'Silahkan Cek Menu Piutang > Hapus Piutang',
                        duration: 0
                    });
                });

        },
        postPayment: function () {

            if (this.depositAmount > 0 && this.depositType == '') {
                this.modalConfirmDeposit = true;
                return;
            } else {
                this.modalConfirmDeposit = false;
            }

            this.loadingPost = true
            let paymentAllocates = [];
            _.forEach(this.invoiceDues, function (invoiceDue) {
                if ((invoiceDue.allocateAmount + invoiceDue.useDepositAmount != 0 || invoiceDue.allocateAmount + invoiceDue.useDepositMutasi != 0) ||
                    invoiceDue.invoicefee == 0) {
                    let paymentAllocate = {
                        invoicefee: invoiceDue.invoicefee,
                        invoiceDueId: invoiceDue.id,
                        allocateAmount: invoiceDue.allocateAmount,
                        receivableRemaining: invoiceDue.receivableRemaining,
                        useDepositAmount: invoiceDue.useDepositAmount,
                        useDepositMutasi: invoiceDue.useDepositMutasi,
                        description: invoiceDue.description,
                    }
                    paymentAllocates.push(paymentAllocate);
                }
            });

            let subbranchcode = this.searchSelectSubbranch;
            let branchcode = this.searchSelectSubbranch;

            console.log('postPayment', this.amountReceived)
            this.paymentAllocates = paymentAllocates;
            let transactionDate = moment(this.paymentDate).format('YYYY/MM/DD')

            let paymentPendingId = this.paymentPendingId;
            let payload = {
                markingHeaderId: this.markingIdSelected,
                amount: this.amountReceived,
                transactionDate: transactionDate,
                description: this.description,
                accountNumber: this.accountNumber,
                depositAmount: this.depositAmount,
                paymentAllocates: this.paymentAllocates,
                depositType: this.depositType,
                category: this.category,
                paymentPendingId: paymentPendingId,
                // creditRound: this.creditRound,
                // coaId: this.creditRound > 0 ? this.coaId : null
            }

            HTTP
                .post('payment/pay', payload)
                .then(response => {
                    this.loadingPost = false

                    this.$Message.success({
                        content: 'Pembayaran Berhasil',
                        duration: 5
                    });

                    HTTP.post('transaction-note/create', { paymentPendingId })
                        .then(response => {
                            this.$Message.success({
                                content: 'Nota transaksi otomatis, berhasil dibuat ! ',
                                duration: 5
                            });

                            if (paymentPendingId) {
                                this.goToPaymentPendingList();
                            } else {
                                this.getInvoiceData();
                            }
                        })
                        .catch(e => {
                            isSuccess = true;
                            isDescriptionResponse = e;

                            this.$Notice.error({
                                title: "Transaction Note Error",
                                desc: isDescriptionResponse,
                                duration: 5
                            });
                        });
                })
                .catch(e => {
                    this.loadingPost = false
                    this.$Notice.error({
                        title: "Payment Error",
                        desc: e,
                        duration: 5
                    });
                })
        },
        postPaymentPending: function () {
                    console.log('Tesss', this.claims);

            if (this.depositAmount > 0 && this.depositType == '') {
                this.modalConfirmDeposit = true;
                return;
            } else {
                this.modalConfirmDeposit = false;
            }

            this.loadingPost = true
            let paymentAllocates = [];
            let paymentDiscountAllocates = [];
            let amountDeposit = 0;

            _.forEach(this.invoiceDues, function (invoiceDue) {
                if ((invoiceDue.allocateAmount + invoiceDue.useDepositAmount != 0 ||
                    invoiceDue.allocateAmount + invoiceDue.useDepositMutasi != 0) ||
                    invoiceDue.invoicefee == 0) {

                    amountDeposit += invoiceDue.useDepositMutasi;

                    let paymentAllocate = {
                        invoicefee: invoiceDue.invoicefee,
                        invoiceDueId: invoiceDue.id,
                        allocateAmount: invoiceDue.allocateAmount,
                        receivableRemaining: invoiceDue.receivableRemaining,
                        useDepositAmount: invoiceDue.useDepositAmount,
                        useDepositMutasi: invoiceDue.useDepositMutasi,
                        description: invoiceDue.description,
                    }
                    paymentAllocates.push(paymentAllocate);
                }

                if (invoiceDue.discountAmount && invoiceDue.discountDescription) {
                    let paymentAllocate = {
                        invoicefee: invoiceDue.invoicefee,
                        invoiceDueId: invoiceDue.id,
                        allocateAmount: invoiceDue.discountAmount,
                        receivableRemaining: invoiceDue.receivableRemaining,
                        useDepositAmount: 0,
                        useDepositMutasi: 0,
                        description: invoiceDue.discountDescription,
                    }
                    paymentDiscountAllocates.push(paymentAllocate);
                }
            });

            //Jika sisa dan dipilih depsoit, maka amount - deposit karena deposit mutasi masuk ke kredit
            if(this.depositAmount > 0 && this.depositType == 'DFM') {
              // this.amountReceived = this.amountReceived - this.depositAmount
            }

            // if(amountDeposit != 0) {
            //   this.amountReceived = this.amountReceived - amountDeposit;
            // }

            this.paymentAllocates = paymentAllocates;
            let transactionDate = moment(this.paymentDate).format('YYYY/MM/DD')

            let paymentPendingId = this.paymentPendingId;
            let payload = {
                markingHeaderId: this.markingIdSelected,
                amount: this.amountReceived ,
                transactionDate: transactionDate,
                description: this.description,
                accountNumber: this.accountNumber,
                depositAmount: this.depositAmount,
                paymentAllocates: this.paymentAllocates,
                depositType: this.depositType,
                category: this.category,
                paymentPendingId: paymentPendingId,
                paymentDiscountAllocates: paymentDiscountAllocates,
                amountDeposit: amountDeposit,
                claims: this.claims,
                // creditRound: this.creditRound,
                // coaId: this.creditRound > 0 ? this.coaId : null
            }

            console.log({ payload });

            HTTP
                .post('payment/pay?username='+this.username+'&mutasi_id='+this.paymentPendingId, payload)
                .then(response => {
                    this.loadingPost = false

                    this.$Message.success({
                        content: 'Pembayaran Berhasil',
                        duration: 5
                    });

                    HTTP.post('transaction-note/create', { paymentPendingId })
                        .then(response => {
                            this.$Message.success({
                                content: 'Nota transaksi otomatis, berhasil dibuat ! ',
                                duration: 5
                            });

                            if (paymentPendingId) {
                                this.goToPaymentPendingList();
                            } else {
                                this.getInvoiceData();
                            }
                        })
                        .catch(e => {
                            isSuccess = true;
                            isDescriptionResponse = e;

                            this.$Notice.error({
                                title: "Transaction Note Error",
                                desc: isDescriptionResponse,
                                duration: 5
                            });
                        });
                })
                .catch(e => {
                    this.loadingPost = false
                    this.$Notice.error({
                        title: "Payment Error",
                        desc: e,
                        duration: 5
                    });
                })
        },
        postPaymentByGroup: function () {
            if (this.depositAmount > 0 && this.depositType == '') {
                this.modalConfirmDeposit = true;
                return;
            } else {
                this.modalConfirmDeposit = false;
            }

            var paymentDate = this.paymentDate;
            var description = this.description;
            var accountNumber = this.accountNumber;
            var depositAmount = this.depositAmount;
            var depositType = this.depositType;
            var category = this.category;
            var paymentPendingId = this.paymentPendingId;
            var markingIdSelected = this.markingIdSelected;
            console.info(markingIdSelected)

            var groupByCategory = _.groupBy(this.invoiceDues, invoiceDue => invoiceDue.markingHeaderId);
            this.loadingPost = true

            var isResponse = true;
            var isDescriptionResponse = '';
            var isDeposit = false;

            let paymentPromises = [];

            _.forEach(groupByCategory, function (invoiceDues) {

                console.info("invoiceDues", invoiceDues)
                let paymentAllocates = [];
                let amount = 0;
                let remainingAmount = 0;
                var markingheaderid = '';
                var paymentDiscountAllocates = [];

                _.forEach(invoiceDues, function (invoiceDue) {

                    console.info('invoiceDue', invoiceDue)

                    if ((invoiceDue.allocateAmount + invoiceDue.useDepositAmount != 0 ||
                        invoiceDue.allocateAmount + invoiceDue.useDepositMutasi != 0) ||
                        invoiceDue.invoicefee == 0) {
                        let paymentAllocate = {
                            invoicefee: invoiceDue.invoicefee,
                            invoiceDueId: invoiceDue.id,
                            allocateAmount: invoiceDue.allocateAmount,
                            receivableRemaining: invoiceDue.receivableRemaining,
                            useDepositAmount: invoiceDue.useDepositAmount,
                            useDepositMutasi: invoiceDue.useDepositMutasi,
                            description: invoiceDue.description,
                        }

                        // amount = amount + invoiceDue.allocateAmount + invoiceDue.useDepositAmount + invoiceDue.useDepositMutasi;
                        amount = amount + invoiceDue.allocateAmount; // + invoiceDue.useDepositAmount;
                        paymentAllocates.push(paymentAllocate);

                        if (invoiceDue.allocateAmount > invoiceDue.receivableRemaining) {
                            isDeposit = true;
                            if (invoiceDue.allocateAmount - invoiceDue.receivableRemaining > 0) {
                                remainingAmount = remainingAmount + (invoiceDue.allocateAmount - invoiceDue.receivableRemaining);
                            }
                        }
                    }

                    markingheaderid = invoiceDue.markingHeaderId;

                    if (invoiceDue.discountAmount && invoiceDue.discountDescription) {
                        let paymentAllocate = {
                            invoicefee: invoiceDue.invoicefee,
                            invoiceDueId: invoiceDue.id,
                            allocateAmount: invoiceDue.discountAmount,
                            receivableRemaining: invoiceDue.receivableRemaining,
                            useDepositAmount: 0,
                            useDepositMutasi: 0,
                            description: invoiceDue.discountDescription,
                        }
                        paymentDiscountAllocates.push(paymentAllocate);
                    }
                });

                if (amount >= 0) {
                    let transactionDate = moment(paymentDate).format('YYYY/MM/DD')

                    if (isDeposit == true) {
                        depositAmount = remainingAmount;
                    } else {
                        depositAmount = 0;
                    }

                    let payload = {
                        markingHeaderId: markingheaderid,
                        markingGroupId: markingIdSelected,
                        amount: amount,
                        transactionDate: transactionDate,
                        description: description,
                        accountNumber: accountNumber,
                        depositAmount: depositAmount,
                        paymentAllocates: paymentAllocates,
                        depositType: depositType,
                        category: category,
                        paymentPendingId: paymentPendingId,
                        paymentDiscountAllocates: paymentDiscountAllocates
                    }

                    // push hit api into array
                    if (payload.amount > 0 || payload.paymentAllocates.length > 0 || payload.paymentDiscountAllocates.length > 0) {
                        paymentPromises.push(
                            HTTP.post('payment/pay', payload)
                                .then(response => {
                                    isResponse = true;
                                })
                                .catch(e => {
                                    isSuccess = true;
                                    isDescriptionResponse = e;
                                })
                        );
                    }
                }
            });

            // wait until all payment/pay requests are done
            Promise.all(paymentPromises)
                .then(() => {
                    if (isResponse) {
                        this.loadingPost = false

                        this.$Message.success({
                            content: 'Pembayaran berhasil !',
                            duration: 5
                        });
                    } else {
                        this.loadingPost = false

                        this.$Notice.error({
                            title: "Payment Error",
                            desc: isDescriptionResponse,
                            duration: 5
                        });
                    }

                    // create Transaction Note - New
                    return HTTP.post('transaction-note/create', { paymentPendingId });
                })
                .then(response => {
                    this.$Message.success({
                        content: 'Nota transaksi otomatis, berhasil dibuat ! ',
                        duration: 5
                    });

                    if (paymentPendingId) {
                        this.goToPaymentPendingList();
                    } else {
                        this.getInvoiceDataByGroupMarking();
                    }
                })
                .catch(e => {
                    isSuccess = true;
                    isDescriptionResponse = e;

                    this.$Notice.error({
                        title: "Transaction Note Error",
                        desc: isDescriptionResponse,
                        duration: 5
                    });
                });
        },
        getMarkingByCode: _.debounce(
            function (query) {
                if (query && query !== '' && this.isGroup == false) {
                    this.loadingGetMarking = true;
                    HTTP
                        .post('marking/getBySnapshot', {
                            markingHeaderId: query,
                            subbranchcode: this.searchSelectSubbranch || null
                        })
                        .then(response => {
                            this.loadingGetMarking = false;
                            let data = response.data;

                            const list = data.map(item => {
                                return {
                                    value: item.markingheaderid,
                                    label: item.markingheadercode
                                };
                            });

                            this.optionMarkings = list.filter(item => item.label.toLowerCase().indexOf(query.toLowerCase()) > -1);
                        })
                        .catch(e => {
                            this.$Notice.error({
                                title: "Error",
                                desc: e,
                                duration: 5
                            });
                        })
                } else {
                    this.optionMarkings = [];
                }
            }, 300
        ),
        getGroupMarkingByCode: _.debounce(
            function (query) {
                if (query !== '' && this.isGroup) {
                    this.loadingGetMarking = true;
                    HTTP
                        .post('markingGroup/getByCode', {
                            groupName: query
                        })
                        .then(response => {
                            this.loadingGetMarking = false;
                            let data = response.data;

                            const list = data.map(item => {
                                return {
                                    value: item.id,
                                    label: item.code
                                };
                            });

                            this.optionGroupMarkings = list.filter(item => item.label.toLowerCase().indexOf(query.toLowerCase()) > -1);
                        })
                        .catch(e => {
                            this.$Notice.error({
                                title: "Error",
                                desc: e,
                                duration: 5
                            });
                        })
                } else {
                    this.optionGroupMarkings = [];
                }
            }, 300
        ),
        goToPaymentPendingList: function () {
            // let uriParam = ""
            // if (this.uriType == "all") {
            //     uriParam = this.uriType + '/' + this.startEndDate
            // } else {
            //     uriParam = this.uriType + '/' + this.bankAccountId
            // }

            // this.$router.push({ path: '/payment/paymentPending/list-data/' + uriParam })
            // this.$router.push({ path: '/payment/paymentPending/list-data/search/-' })
            this.$router.push({
                path: `/payment/paymentPending/list-data/search/${Date.now()}`,
                // query: { refresh: Date.now() }
            })
        },
        setMarkingCode: function () {
            this.markingIdSelected = ''
        },
        groupClickHandle: function (indexTab) {
            console.info('groupClickHandle', this.markingIdSelected)
            this.selectGroup = this.receivableGroup[indexTab].markingheadercode
            let tempSum = 0
            this.receivableGroup[indexTab].invoiceDue.forEach(element => {
                tempSum += element.allocateAmount
            });
            this.totalAmountSelect = tempSum

            const markingHeaderId = this.receivableGroup[indexTab].invoiceDue[0].markingHeaderId

            HTTP
                .get('deposit/remaining/' + markingHeaderId)
                .then(response => {
                    this.groupDepositRemaining = response.data.remaining
                })
                .catch(e => {
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                });
        },
        getCOA: function () {
            HTTP.get("coa")
                .then(response => {
                    this.COAs = response.data;
                })
                .catch(e => {
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                });
        },
        getDepositGroup: function () {
            const parent = this;
            let markingHeaderIds = this.listMarkingGroup.map(value => value.markingheaderid);
            let groupDepositRemaining = 0;

            let requests = markingHeaderIds.map(markingHeaderId => {
                return HTTP.get('deposit/remaining/' + markingHeaderId)
                    .then(response => {
                        groupDepositRemaining += response.data.remaining;
                    })
                    .catch(e => {
                        parent.$Notice.error({
                            title: "Error",
                            desc: e,
                            duration: 5
                        });
                    });
            });

            Promise.all(requests)
              .then(() => {
                  parent.depositRemaining += groupDepositRemaining
              });

        },
        getDepositMutasiGroup: function () {
            const parent = this;
            let markingHeaderIds = this.listMarkingGroup.map(value => value.markingheaderid);
            let groupDepositRemaining = 0;

            let requests = markingHeaderIds.map(markingHeaderId => {
                return HTTP.get('deposit/mutasi/' + markingHeaderId)
                    .then(response => {
                        groupDepositRemaining += response.data.remaining;
                    })
                    .catch(e => {
                        parent.$Notice.error({
                            title: "Error",
                            desc: e,
                            duration: 5
                        });
                    });
            });

            Promise.all(requests)
              .then(() => {
                  parent.depositMutasiRemaining += groupDepositRemaining
              });

        },
        getgroupMarkingList: function () {
            HTTP
                .post('markingGroup/getByCode', {
                    groupName: this.paymentPendingMarkingGroup
                })
                .then(response => {
                    this.loadingGetMarking = false;
                    let data = response.data[0].detail;

                    const list = data.map(item => {
                        return {
                            id: item.id,
                            markingheadercode: item.markingheadercode,
                            markingheaderid: item.markingheaderid
                        };;
                    });

                    this.listMarkingGroup = list
                    this.getDepositGroup()
                    this.getDepositMutasiGroup()
                })
                .catch(e => {
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                })
        },
        // post receivable as deposit
        postReceivableAsDeposit: function () {
            this.loadingPost = true
            let transactionDate = moment(this.paymentDateProp, 'DD/MM/YYYY').format("YYYY-MM-DD");

            let payload = {
                markingHeaderId: this.markingIdSelected,
                transactionDate: transactionDate,
                description: "Tambah Deposit dari Mutasi",
                amount: this.paymentPendingAmount,
                paymentPendingId: this.paymentPendingId // untuk update payment_pending as isPayment
            }

            HTTP
                .post('receivable/deposit/create', payload)
                .then(response => {
                    this.$Message.success({
                        content: 'Total mutasi berhasil ditambahkan sebagai deposit',
                        duration: 5
                    });

                    this.loadingPost = false
                    this.modalConfirmAutoDeposit = false
                })
                .catch(e => {
                    this.loadingPost = false
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                })
        },
        getClaims: function () {
            this.loadingGetClaims = true;
            this.optionClaims = [];
            this.receivableClaim = [];
            this.claims = [];

            let claimData = [];

            let payload = {
              markingHeaderId: this.markingIdSelected,
              transactionDate: this.paymentDateProp
            }

            HTTP
                .post('claim/drafts', payload)
                .then(response => {
                    this.loadingGetClaims = false
                    console.log(response.data.data);

                    let claim = response.data.data.map(function (value) {
                        return {
                            value: value.id,
                            label: numeral(value.total_claim).format('0,0.00') + ' - ' + value.receivable.description
                        }
                    })

                    this.optionClaims = claim
                    claimData = response.data.data

                    claimData.forEach(data => {
                      this.receivableClaim.push({
                        id: data.receivable.id,
                        claimId: data.id,
                        description: data.receivable.description,
                      });
                    });

                    this.invoiceDues.forEach(invoiceDue => {
                      invoiceDue.claimStatus = null;

                      this.receivableClaim.forEach(receivable => {
                        console.log('invoiceDue', invoiceDue.receivableId, 'receivable', receivable.id);
                        if (invoiceDue.receivableId === receivable.id) {
                          invoiceDue.claimStatus = ' - (Ada Claim)';
                        }
                      });
                    });

                    // const receivableMap = new Map(
                    //   this.receivableClaim.map(item => [item.id, true])
                    // );

                    // this.invoiceDues.forEach(invoiceDue => {
                    //   if (receivableMap.has(invoiceDue.receivableId)) {
                    //     invoiceDue.claimStatus = ' (Ada Claim)';
                    //   }
                    // });



                }).catch(err => {
                    this.loadingGetClaims = false
                    this.$Notice.error({
                        title: "Error",
                        desc: err,
                        duration: 5
                    });
                })

        },
    },
    filters: {
        currency: function (value) {
            if (!value) return ''
            return numeral(value).format('0,0')
        },
        currencyInter: function (value) {
            if (!value) return ''
            return numeral(value).format('0,0.00')
        },
    },
    beforeMount() {
        this.paymentDate = this.paymentDateProp // set & handle mutating a prop directly
        let prefixMarking = this.paymentPendingMarking ? this.paymentPendingMarking.split('/')[0] : this.paymentPendingMarkingGroup.split('/')[0]
        if (prefixMarking == 'SBR' || prefixMarking == 'SBRT' || prefixMarking == 'CTH') {
            this.isSpecialMarking = true
        }
    },
    async mounted() {
        this.getInvoiceData()
        this.getInvoiceDataByGroupMarking()
        if (this.isGroup) {
            this.getgroupMarkingList()
        }

    },
    watch: {
        amountReceived: function (newAmountReceived) {
            this.setResidueAmount(false)
        }
    },
    updated() {
        if(this.isSpecialMarking) {
          this.isbalanceAmount = parseFloat(this.amountReceived - this.totalUseDepositMutasi).toFixed(2) == this.paymentPendingAmount
          this.diffAmount = parseFloat((this.paymentPendingAmount - (this.amountReceived - this.totalUseDepositMutasi)).toFixed(2)) + 0;

        } else {
          this.isbalanceAmount = (this.amountReceived - this.totalUseDepositMutasi) == this.paymentPendingAmount
          this.diffAmount = this.paymentPendingAmount - (this.amountReceived - this.totalUseDepositMutasi)
        }

        // this.isbalanceAmount = this.amountReceived == this.paymentPendingAmount
        // console.log(this.amountReceived + '-' + pendingAmount)
    },
    created() {
        this.getSubbranch();
        this.getCOA();
    }
}

function groupBy(dataToGroupOn, fieldNameToGroupOn, fieldNameForGroupName, fieldNameForChildren) {
    var result = _.chain(dataToGroupOn)
        .groupBy(fieldNameToGroupOn)
        .toPairs()
        .map(function (currentItem) {
            return _.zipObject([fieldNameForGroupName, fieldNameForChildren], currentItem);
        })
        .value();
    return result;
}

</script>



// WEBPACK FOOTER //
// PaymentPendingAdd.vue?4035e6c3